import Callback from './Callback'
import Install from './Install'
import InstallFeedback from './InstallFeedback'

const Auth = {
  Callback,
  Install,
  InstallFeedback,
}

export default Auth
